import { useScriptTag, useStyleTag } from '@vueuse/core'

export function useRecaptcha() {
  const config = useRuntimeConfig()
  const state = reactive({
    isScriptStartLoad: false,
    isReady: false,
  })

  const { load: loadStyle } = useStyleTag('.grecaptcha-badge { visibility: hidden; }', {
    manual: true,
  })
  const { load: loadScript } = useScriptTag(
    `https://www.google.com/recaptcha/enterprise.js?render=${config.public.RECAPTCHA_SITE_KEY}`,
    () => {
      // window.grecaptcha.enterprise.ready(function () {
      //   console.log('recaptcha ready!')
      //   state.isReady = true
      // })
    },
    {
      manual: true,
    }
  )

  const init = async () => {
    await Promise.all([loadScript(true), loadStyle()])
  }

  const execute = async (action: string, callback?: (token: string) => any) => {
    if (!state.isReady) await init()
    return new Promise((resolve, reject) => {
      window.grecaptcha.enterprise.ready(async () => {
        state.isReady = true
        console.log('recaptcha ready!')
        try {
          const token = await window.grecaptcha.enterprise.execute(config.public.RECAPTCHA_SITE_KEY, { action })

          if (callback) return resolve(callback(token))
          return resolve(token)
        } catch (error) {
          console.error('useRecaptcha:execute:error', error)
          reject(error)
        }
      })
    })
  }

  init()

  return {
    init,
    execute,
  }
}
